jQuery(document).ready(function(){
  $('.subscrip-custom').hide();
  $('.substab-table').hide();
  //$('#shopify-block-2b29c733-2ed5-44dc-a758-361a36a7beda').hide();
  $(".tab__holder #tab__1").click(function(){
    $('#appstle_selling_plan_label_10').trigger('click');
    $('#shopify-block-b5602975-1810-425f-84b5-60b551939760').show();
    $('#shopify-block-2b29c733-2ed5-44dc-a758-361a36a7beda').hide();
    $('.subscrip-custom').hide();
    $('.substab-table').hide();
    $('#tab__1').addClass('tab--active');
    $('#tab__2').removeClass('tab--active');
  });
  $(".tab__holder #tab__2").click(function(){
    $('#appstle_selling_plan_label_20').trigger('click');
    $('#shopify-block-b5602975-1810-425f-84b5-60b551939760').hide();
    $('#shopify-block-2b29c733-2ed5-44dc-a758-361a36a7beda').show();
    $('.subscrip-custom').show();
    $('.substab-table').show();
    $('#tab__2').addClass('tab--active');
    $('#tab__1').removeClass('tab--active');
  });


  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav'
  });
  $('.slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: true,
    centerMode: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  });
  // $('.slider-for').slickLightbox({
  //   itemSelector        : 'a',
  //   navigateByKeyboard  : true
  // });
  setTimeout(() => {
    $('[data-fancybox="gallery"]').fancybox({
      buttons: [
        "zoom",
        "close"
      ],
      loop: false,
      protect: true
    });
  }, 1000);

});